import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import Iconify from '../Iconify';

const GeneralFiltersAccordionWrapper = ({ title = 'فیلترها', children }) => {
  return (
    <Accordion defaultExpanded sx={{ mx: '4px', borderRadius: '8px', mb: '16px', px: '10px' }} className="!shadow-none *:!shadow-none">
      <AccordionSummary
        expandIcon={<Iconify className="text-xl lg:text-2xl" icon={'mingcute:down-line'} />}
        aria-controls="filter-form-content"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Iconify className="text-xl lg:text-2xl" icon={'line-md:filter'} />
          <Typography>{title}</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default GeneralFiltersAccordionWrapper;
